export const AppUrl = {
	HOME: "/",
	LOGIN: "/login",
	PRESCHOOL: "/preschool",
	GRADE_1: "/grade1",
};

export const apiUrl = process.env.REACT_APP_API_URL || "";
